// Login / Forgotten password toggle
import { debounce } from "lodash";
import Plyr from "plyr";
import "slick-carousel";
import { triggerQuickShopModal } from "../modal/handleQuickshopModal";

$(window).on("load", () => {
  if (
    window.location.pathname === "/account/login" &&
    window.location.hash === "#form--recover"
  ) {
    const $this = $(".forgotten-pass");
    const targetString = $this.attr("href").replace("#", "");
    $(`.${targetString}`).show();
    $this.closest("form").parent().hide();
    history.pushState(
      "",
      "",
      window.location.href.replace(window.location.hash, "")
    );
  }
});

if (document.querySelector(".template-collection")) {
  // Added this is a temporary fix as boost cards weren't registering a click event.
  document.addEventListener("click", function (e) {
    const { dataset } = e.target;
    if (dataset?.variantId && !dataset.wishlist) {
      triggerQuickShopModal(
        dataset.productHandle,
        dataset.variantId.includes(": ")
          ? dataset.variantId.split(": ")[1]
          : dataset.variantId
      );
    }
  });
} else {
  document
    .querySelectorAll(".product-item-new .list-color-swatches--small input")
    .forEach((elem) =>
      elem.addEventListener("click", function () {
        const $this = $(this);
        triggerQuickShopModal(
          $this.data("productHandle"),
          $this.data("variantId").includes(": ")
            ? $this.data("variantId").split(": ")[1]
            : $this.data("variantId")
        );
      })
    );
}

$(".forgotten-pass, .loginfrom-link").on("click", function (e) {
  e.preventDefault();
  const $this = $(this);
  const targetString = $this.attr("href").replace("#", "");
  $(`.${targetString}`).show();
  $this.closest("form").parent().hide();
});

// Address new
$(".addresses__actions .btn--new, .form--address-new .btn--cancel").on(
  "click",
  function (e) {
    e.preventDefault();
    const $this = $(this);
    const targetString = $this.attr("href").replace("#", "");
    $(`.${targetString}`).toggle();
  }
);

// Collection sortBy
$("#sortBy").on("change", function () {
  Shopify.queryParams = {};
  const $this = $(this);
  const thisVal = $this.val();

  if (location.search) {
    const getArgumentsArray = location.search.substr(1).split("&");
    getArgumentsArray.map(function (ele) {
      const eleArray = ele.split("=");
      Shopify.queryParams[decodeURIComponent(eleArray[0])] = decodeURIComponent(
        eleArray[1]
      );
    });
  }

  Shopify.queryParams.sort_by = thisVal;
  location.search = jQuery.param(Shopify.queryParams);
});

// Product price update
$(".product-single__variants").on("change", function () {
  const $this = $(this);
  const $option = $this.find("option:selected");
  const $btnSubmit = $this
    .closest("form")
    .find('input[type="submit"], button[type="submit"]');
  const thisPrice = $this.find("option:selected").data("price");

  $(".product__price").html(thisPrice);

  if ($option.is(":disabled")) {
    $btnSubmit
      .html(Shopify.theme.locale.products.product.sold_out)
      .prop("disabled", true);
  } else {
    $btnSubmit
      .html(Shopify.theme.locale.products.product.add_to_cart)
      .prop("disabled", false);
  }
});

// Address province option
$('select[name="address[country]"]').each(function () {
  const $this = $(this);
  const thisID = $this.attr("id");
  const province = $this
    .closest("form")
    .find('select[name="address[province]"]');
  const provinceID = province.attr("id");
  const provinceHolderID = province.closest(".form__row").attr("id");
  new Shopify.CountryProvinceSelector(thisID, provinceID, {
    hideElement: provinceHolderID,
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll(".js-plyr");

  videos.forEach((video) => {
    const player = new Plyr(video);
  });

  const responsiveVideos = document.querySelectorAll(".js-responsive-video");

  const addSourceToVideo = (elem, src) => {
    const types = ["video/mp4", "video/webm"];

    if (elem.innerHTML !== "") {
      elem.innerHTML = "";
    }

    types.forEach((type) => {
      const source = document.createElement("source");
      source.src = src;
      source.type = type;

      elem.appendChild(source);
    });
  };

  const determineVideo = (elem) => {
    if (window.innerWidth < 768) {
      addSourceToVideo(
        elem,
        elem.dataset.mobileVideo || elem.dataset.desktopVideo
      );
    } else {
      addSourceToVideo(elem, elem.dataset.desktopVideo);
    }
  };

  const handleResponsiveVideos = () => {
    responsiveVideos?.forEach((video) => {
      determineVideo(video);
    });
  };

  handleResponsiveVideos();
  const width = window.innerWidth;

  window.addEventListener(
    "resize",
    width !== window.innerWidth && debounce(handleResponsiveVideos, 500)
  );
});
